import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import TheLoading from "@/components/TheLoading.vue";

export interface Props {
  type?: "primary" | "secondary";
  loading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeyButton',
  props: {
    type: { default: "primary" },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_ctx.type)
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(TheLoading, {
          key: 0,
          class: "loading"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass([_ctx.type, _ctx.loading ? 'hidden' : ''])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})